export class StepData {
  Overview: Overview | undefined = undefined;
  HowToApply: {} = {};
  Verification: {} = {};
  TermsOfUse: TermsOfUse = new TermsOfUse();
  PersonalInformation: PersonalInformation = new PersonalInformation();
  EvacuationLocation: EvacuationLocation = new EvacuationLocation();
  TemporaryContactInfo: TemporaryContactInfo = new TemporaryContactInfo();
  FirstNationStatus: FirstNationStatus = new FirstNationStatus();
  FamilyMembers: FamilyMembers = new FamilyMembers();
  PaymentInformation: PaymentInformation | {} = new PaymentInformation();

  constructor(init?: Partial<StepData>) {
    Object.assign(this, init);

    // Always ensure the mapping happens after assignment
    mapPersonalDetailsToPaymentInformation(
      this.PaymentInformation,
      this.PersonalInformation,
    );
  }
}

export interface Overview {
  applicationType: string;
  forcedToLeave: string;
  expectToEvacuate: string;
  applicationTypeId: string;
}

export class TermsOfUse {
  // Spelling Mistake in code I guess
  acceptTermOfUse: boolean = true;

  constructor(init?: Partial<TermsOfUse>) {
    Object.assign(this, init);
  }
}

export class PersonalInformation {
  ignoreUserData: boolean = true;
  isPOBox: string = "";
  givenName: string = "";
  middleName: string = "";
  surname: string = "";
  dob: Date = new Date();
  gender: string = "";
  streetAddressLine1: string = "";
  streetAddressLine2: string = "";
  locality: string = "";
  province: string = "";
  country: string = "";
  email: string = "";
  mobile: string = "";
  phone: string = "";
  fullName: string = "";
  postalCode: string = "";

  constructor(init?: Partial<PersonalInformation>) {
    if (init) {
      mapPersonalDetailsToPersonalInformation(this, init);
    }
  }
}

function mapPersonalDetailsToPersonalInformation(
  pi: PersonalInformation,
  pd: any,
) {
  if (!pd) return;
  pi.givenName = pd.firstName;
  pi.middleName = pd.middleName;
  pi.surname = pd.lastName;
  pi.fullName = pd.fullName;
  pi.country = pd.country;
  pi.dob = pd.dob;
  pi.gender = pd.gender;
  pi.locality = pd.locality;
  pi.mobile = pd.mobile;
  pi.phone = pd.phone;
  pi.province = pd.province;
  pi.streetAddressLine1 = pd.streetAddressLine1;
  pi.streetAddressLine2 = pd.streetAddressLine2;
  pi.postalCode = pd.postalCode;
}

export class EvacuationLocation {
  mapLat: number = 0;
  mapLng: number = 0;
  // Spelling Mistake in code I guess
  acceptDeclation: boolean = false;

  constructor() {
    let evacuationLocation = { mapLat: 0, mapLng: 0 };
    // if (process.env.REACT_APP_MAP_WITHIN_POLYGON) {
    //   try {
    //     evacuationLocation = JSON.parse(
    //       process.env.REACT_APP_MAP_WITHIN_POLYGON,
    //     );
    //   } catch {
    //     // fallback to default if parsing fails
    //     evacuationLocation = { mapLat: 0, mapLng: 0 };
    //   }
    // }

    this.mapLat = evacuationLocation.mapLat;
    this.mapLng = evacuationLocation.mapLng;
  }
}

export class TemporaryContactInfo {
  returnedToHome: string = "N";
  usePersonalNumber: boolean = true;
  tempPhoneNumber: string = "";
}

export class FirstNationStatus {
  isIndigenous: string = "N";
  band: string = "211";
  family: string = "10100";
  position: string = "10";
  FNIHB: string = "91919191";
  livesOnReserve: string = "Y";

  constructor(init?: Partial<FirstNationStatus>) {
    Object.assign(this, init);
  }
}

export class FamilyMembers {
  familyMembers: FamilyMember[] = [];
  acceptLegalRepresentative: boolean = false;

  constructor(init?: Partial<FamilyMembers>) {
    Object.assign(this, init);
  }
}

export interface FamilyMember {
  relationship: string;
  givenName: string;
  middleName: string;
  surname: string;
  dob: Date;
  gender: string;
  isIndigenous: string;
  id: string;
  band: string;
  family: string;
  position: string;
  FNIHB: string;
  livesOnReserve: string;
  isGenerated: boolean;
  generation?: number;
}

export class PaymentInformation {
  receivePayment: string = "e-transfer";
  usePersonalEmail: boolean = true;
  email: string = "";
  confirmEmail: string = "";
  receiveETransfer: string = "email";
  usePersonalNumber: boolean = true;
  mobile: string = "";
  confirmMobile: string = "";
  institutionNumber: string = "003";
  transitNumber: string = "00001";
  bankAccount: string = "5006100";
  confirmBankAccount: string = "5006100";
  bankName: string = "Bank of Montreal";

  constructor(init?: Partial<PaymentInformation>) {
    if (init) {
      mapPersonalDetailsToPaymentInformation(this, init);
    }
  }
}

function mapPersonalDetailsToPaymentInformation(
  paymentInfo: any,
  personalInfo: Partial<PersonalInformation>,
) {
  if (!personalInfo) return;
  paymentInfo.email = personalInfo.email;
  paymentInfo.confirmEmail = personalInfo.email;
  paymentInfo.mobile = personalInfo.mobile;
  paymentInfo.confirmMobile = personalInfo.mobile;
}
